import css from 'styled-jsx/css';

export default css`
  .row {
    margin-bottom: 15px;
  }

  label,
  .label {
    display: block;
    font-weight: normal;
    margin-bottom: 8px;
  }
`;



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/homes/styles.js